import React, { useEffect, useState } from "react";
import app from "../util/firebase";
import AQIimg from "../AQI.PNG";
import {
  getDatabase,
  ref,
  set,
  update,
  push,
  orderByChild,
  equalTo,
  query,
  remove,
  onValue,
} from "firebase/database";
// eslint-disable-next-line
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DateTimePicker from "@mui/lab/DateTimePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
// eslint-disable-next-line
import relativeTime from "dayjs/plugin/relativeTime";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactEnvironmentChart from "react-environment-chart";
import {
  Humidity,
  Temperature,
  Intensity,
  Tvoc,
  Electricity,
  PM,
} from "react-environment-chart";
import {
  Button,
  Dialog,
  IconButton,
  Slide,
  TextField,
  Grid,
  Card,
  CardActions,
  CardContent,
  DialogTitle,
  DialogContent,
  DialogContentText,
  useMediaQuery,
  CircularProgress,
  LinearProgress,
  DialogActions,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Slider from "@mui/material/Slider";

export default function Environment() {
  const useStyles = makeStyles((theme) => ({
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    // toolbar: theme.mixins.toolbar,
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    submitButton: {
      display: "block",
      color: "white",
      textAlign: "center",
      position: "absolute",
      top: 14,
      right: 10,
    },
    floatingButton: {
      position: "fixed",
      bottom: 0,
      right: 0,
    },
    form: {
      width: "98%",
      marginLeft: 13,
      marginTop: theme.spacing(14),
    },
    toolbar: theme.mixins.toolbar,
    root: {
      minWidth: 470,
      margin: 24,
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    pos: {
      marginBottom: 12,
    },
    uiProgess: {
      position: "fixed",
      zIndex: "1000",
      height: "31px",
      width: "31px",
      left: "50%",
      top: "35%",
    },
    dialogeStyle: {
      maxWidth: "50%",
    },
    viewRoot: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    cardActions: {
      marginLeft: "auto",
      // "&:hover": {
      color: "primary",
      // },
    },
  }));
  ChartJS.register(ArcElement, Tooltip, Legend);
  const theme = useTheme();
  const db = getDatabase(app);

  const [temperatureValue, setTemperatureValue] = useState(10);
  const [temperatureColor, setTemperatureColor] = useState("LightCyan");
  const classes = useStyles();
  const environmentRef = query(ref(db, "da6d/" + "environment"));
  const temperatureRef = query(
    ref(db, "da6d/" + "environment/" + "temperature")
  );
  const humidityRef = query(ref(db, "da6d/" + "environment/" + "humidity"));
  const AQIRef = query(ref(db, "da6d/" + "environment/" + "AQI"));
  useEffect(() => {
    // setLoading(true);
    onValue(temperatureRef, (snapshot) => {
      // snapshot.forEach((childSnapshot) => {
      setTemperatureValue(snapshot.val());
      checkTemperature(snapshot.val());
      // });
    });
    onValue(humidityRef, (snapshot) => {
      // snapshot.forEach((childSnapshot) => {
      setHumidityValue(snapshot.val());
      checkHumidity(snapshot.val());
      // });
    });
    onValue(AQIRef, (snapshot) => {
      // snapshot.forEach((childSnapshot) => {
      setAQIValue(snapshot.val());
      checkAQI(snapshot.val());
      // });
    });
  }, []);
  const checkTemperature = (value) => {
    var tempInC = Math.round(((value - 32) * 5) / 9);
    if (tempInC <= 2) {
      setTemperatureColor("LightCyan");
    } else if (tempInC >= 29) {
      setTemperatureColor("orange");
    } else {
      setTemperatureColor("#F0FFF0");
    }

    update(environmentRef, { temperature: value });
  };
  const increaseTemperature = () => {
    const newTemperature = temperatureValue + 1;
    setTemperatureValue(newTemperature);

    checkTemperature(newTemperature);
  };

  const decreaseTemperature = () => {
    const newTemperature = temperatureValue - 1;
    setTemperatureValue(newTemperature);
    checkTemperature(newTemperature);
  };

  const [humidityValue, setHumidityValue] = useState(80);
  const [humidityColor, setHumidityColor] = useState("#F0FFF0");
  const [dryValue, setDryValue] = useState(24);
  const [wetValue, setWetValue] = useState(55);
  // const minHumidityIdealRangeDistance = 10;
  // const classes = useStyles();
  const [humidityIdealRange, setHumidityIdealRange] = React.useState([
    dryValue,
    wetValue,
  ]);

  const handleChangeHumidityIdealRange = (
    event,
    newHumidityIdealRange,
    activeThumb
  ) => {
    setHumidityIdealRange(newHumidityIdealRange);
    setDryValue(newHumidityIdealRange[0]);
    setWetValue(newHumidityIdealRange[1]);
    checkHumidity(humidityValue);
  };
  const checkHumidity = (value) => {
    if (value <= dryValue) {
      setHumidityColor("orange");
    } else if (value >= wetValue) {
      setHumidityColor("LightCyan");
    } else {
      setHumidityColor("#F0FFF0");
    }
    update(environmentRef, { humidity: value });
  };
  const increaseHumidity = () => {
    const newHumidity = humidityValue + 1;
    setHumidityValue(newHumidity);

    checkHumidity(newHumidity);
  };

  const decreaseHumidity = () => {
    const newHumidity = humidityValue - 1;
    setHumidityValue(newHumidity);
    checkHumidity(newHumidity);
  };
  ///////////////////////////////////////////////////////////////////////

  const [AQIValue, setAQIValue] = useState(15);
  const [AQIColor, setAQIColor] = useState("#F0FFF0");
  // const [dryValue, setDryValue] = useState(24);
  // const [wetValue, setWetValue] = useState(55);
  // const minHumidityIdealRangeDistance = 10;
  // const classes = useStyles();
  // const [humidityIdealRange, setHumidityIdealRange] = React.useState([
  //   dryValue,
  //   wetValue,
  // ]);

  // const handleChangeHumidityIdealRange = (
  //   event,
  //   newHumidityIdealRange,
  //   activeThumb
  // ) => {
  //   setHumidityIdealRange(newHumidityIdealRange);
  //   setDryValue(newHumidityIdealRange[0]);
  //   setWetValue(newHumidityIdealRange[1]);
  //   checkHumidity(humidityValue);
  // };
  var goodAQI = 50;
  var moderateAQI = 100;
  var usgAQI = 150;
  var unhealthyAQI = 200;
  var veryUnhealthyAQI = 300;
  var HazardousAQI = 500;
  const checkAQI = (value) => {
    if (value <= moderateAQI) {
      setAQIColor("#F0FFF0");
    } else if (value >= unhealthyAQI) {
      setAQIColor("orange");
    } else {
      setAQIColor("lightyellow");
    }
    update(environmentRef, { AQI: value });
  };
  const increaseAQI = () => {
    const newAQI = AQIValue + 1;
    setAQIValue(newAQI);

    checkAQI(newAQI);
  };

  const decreaseAQI = () => {
    const newAQI = AQIValue - 1;
    setAQIValue(newAQI);
    checkAQI(newAQI);
  };
  const humidityData2 = {
    labels: ["Dry", "Confortable", "Wet"],
    datasets: [
      {
        // label: "humidity",
        data: [dryValue, wetValue - dryValue, 100 - wetValue],
        backgroundColor: ["LightCoral", "rgba(46, 204, 113, 1)", "lightblue"],
        borderColor: [
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
        ],
        borderWidth: 5,
      },
    ],
  };

  const humidityData = {
    labels: ["Dry", "Confortable", "Wet"],
    datasets: [
      {
        data: [humidityValue, 1, 99 - humidityValue],
        backgroundColor: [
          "rgba(0,0,0,0)",
          "rgba(46, 204, 113, 1)",
          "rgba(0,0,0,0)",
        ],
        borderColor: ["rgba(0, 0, 0 ,0)", "grey", "rgba(0, 0, 0 ,0)"],
        // borderWidth: 5,
      },
    ],
  };

  const humidityOptions = {
    rotation: -90,
    circumference: 180,
    animation: true,
    cutout: 70,
    layout: { padding: 5 },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };
  var goodAQI = 50;
  var moderateAQI = 100;
  var usgAQI = 150;
  var unhealthyAQI = 200;
  var veryUnhealthyAQI = 300;
  var HazardousAQI = 500;
  const AQIData2 = {
    labels: [
      "Good",
      "Moderate",
      "Unhealthy for Sensitive Groups",
      "Unhealthy",
      "Very Unhealthy",
      "Hazardous",
    ],
    datasets: [
      {
        // label: "humidity",
        data: [
          goodAQI,
          moderateAQI - goodAQI,
          usgAQI - moderateAQI,
          unhealthyAQI - usgAQI,
          veryUnhealthyAQI - unhealthyAQI,
          HazardousAQI - veryUnhealthyAQI,
        ],
        backgroundColor: [
          "#00e400",
          "#ffff00",
          "#ff7e00",
          "#ff0000",
          "#8f3f97",
          "#7e0023",
        ],
        borderColor: [
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
          "rgba(255, 255, 255 ,1)",
        ],
        // borderWidth: 5,
      },
    ],
  };

  const AQIData = {
    // labels: ["Good", "Moderate", "Unhealthy"],
    datasets: [
      {
        data: [AQIValue, 1, 500 - AQIValue],
        backgroundColor: [
          "rgba(0,0,0,0)",
          "rgba(46, 204, 113, 1)",
          "rgba(0,0,0,0)",
        ],
        borderColor: ["rgba(0, 0, 0 ,0)", "grey", "rgba(0, 0, 0 ,0)"],
        // borderWidth: 5,
      },
    ],
  };

  const AQIOptions = {
    rotation: -150,
    circumference: 300,
    animation: true,
    cutout: 30,
    layout: { padding: 5 },
    plugins: {
      legend: {
        display: false,
        position: "chartArea",
        align: "start",
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };
  const temperatureOptions = {
    rotation: -90,
    circumference: 180,
    animation: true,
    cutout: 80,
    layout: { padding: 5 },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
  };
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <Paper>
            <Card
              variant="outlined"
              sx={{
                height: 435,
                ":hover": {
                  boxShadow: 10,
                  color: "#1E3877",
                  // transform: "scale(1.02)",
                },
                backgroundColor: temperatureColor,
              }}
            >
              <CardContent>
                <Typography variant="h5" component="h2">
                  Temperature
                </Typography>
                {/* <Divider /> */}
                <div align="center">
                  <Temperature
                    value={Math.round(((temperatureValue - 32) * 5) / 9)}
                    height={200}
                    tips={[" ", " ", " ", " "]}
                  />
                </div>
                <Typography variant="h2" align="center" component="p">
                  {Math.round(((temperatureValue - 32) * 5) / 9)}°C
                  {/* {Math.round(temperatureValue)}°F */}
                </Typography>

                <div align="center">
                  <Button onClick={increaseTemperature}>+</Button>
                  <Button onClick={decreaseTemperature}>-</Button>
                </div>
                {/* <Divider /> */}
              </CardContent>
            </Card>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Paper>
            <Card
              variant="outlined"
              sx={{
                height: 435,
                ":hover": {
                  boxShadow: 10,
                  color: "#1E3877",
                  // transform: "scale(1.02)",
                },
                backgroundColor: humidityColor,
              }}
            >
              <CardContent>
                <Typography variant="h5" component="h2">
                  Humidity
                </Typography>
                <Box
                  sx={{
                    height: 200,
                    position: "relative",
                    align: "center",
                  }}
                >
                  {/* <Electricity value={humidityValue} /> */}
                  {/* <div style={{ position: "absolute" }}> */}
                  {/* <div
                    align="center"
                    style={{ position: "absolute", width: "100%" }}
                  >
                    <Humidity
                      value={100 - humidityValue}
                      // height={200}
                      tips={[" ", " ", " "]}
                      // style={{ width: "100%" }}
                    />
                  </div> */}
                  {/* </div> */}
                  <Doughnut
                    data={humidityData2}
                    options={humidityOptions}
                    style={{ position: "absolute" }}
                  />

                  <Doughnut
                    data={humidityData}
                    options={humidityOptions}
                    style={{ position: "absolute" }}
                  />
                </Box>
                <Slider
                  sx={{
                    width: 250,
                    // top: "50%",
                    left: "50%",
                    transform: `translateX(-50%)`,
                    // transform: translate(-50%, -50%)
                    color: "lightgrey",
                    "& .MuiSlider-thumb": {
                      color: "white",
                    },
                    "& .MuiSlider-track": {
                      color: "rgba(46, 204, 113, 1)",
                    },
                  }}
                  getAriaLabel={() => "Ideal humidity range"}
                  value={humidityIdealRange}
                  onChange={handleChangeHumidityIdealRange}
                  valueLabelDisplay="auto"
                  // color="primary"
                  disableSwap
                  // getAriaValueText={valuetext}
                />
                {/* </Box> */}
                <Typography variant="h2" align="center" component="p">
                  {Math.round(humidityValue)}%
                </Typography>
                <div align="center">
                  <Button onClick={increaseHumidity}>+</Button>
                  <Button onClick={decreaseHumidity}>-</Button>
                </div>
              </CardContent>
            </Card>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Paper>
            <Card
              variant="outlined"
              sx={{
                height: 435,
                ":hover": {
                  boxShadow: 10,
                  color: "#1E3877",
                  // transform: "scale(1.02)",
                },
                backgroundColor: AQIColor,
              }}
            >
              <CardContent>
                <Typography variant="h5" component="h2">
                  Air Quality Index (AQI)
                </Typography>
                {/* <Divider /> */}
                {/* <div align="center">
                  <Electricity value={AQIValue} height={200} />
                </div> */}
                <img
                  src={AQIimg}
                  alt="AQI"
                  width={"80%"}
                  style={{
                    position: "relative",
                    left: "50%",
                    transform: `translateX(-50%)`,
                  }}
                />
                <Box
                  sx={{
                    height: 200,
                    position: "relative",
                    align: "center",
                  }}
                >
                  <Doughnut
                    data={AQIData2}
                    options={AQIOptions}
                    style={{ position: "absolute" }}
                  />

                  <Doughnut
                    data={AQIData}
                    options={AQIOptions}
                    style={{ position: "absolute" }}
                  />
                </Box>
                <Typography variant="h2" align="center" component="p">
                  {AQIValue}
                </Typography>
                <div align="center">
                  <Button onClick={increaseAQI}>+</Button>
                  <Button onClick={decreaseAQI}>-</Button>
                </div>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
